import axios from "axios";

import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "auth";

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_WEBD_CORE_URI + "/api",
  timeout: 0,
  headers: { "Content-Type": "application/json" }
});

export const textControlAPIClient = axios.create({
  baseURL: process.env.REACT_APP_TEXTCONTROL_URI ,
  timeout: 30000,
  headers: { "Content-Type": "application/json" }
});

const apiScopes = process.env.REACT_APP_AUTH_WEBD_CORE_API_SCOPES;

const apiTokenRequest = {
  scopes: JSON.parse(apiScopes ?? "[]")
};

const getAuthHeader = async () => {
  try {
    const authResult = await msalInstance.acquireTokenSilent(apiTokenRequest);
    return `Bearer ${authResult.accessToken}`;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.logoutRedirect({
        postLogoutRedirectUri: "/",
        logoutHint: msalInstance?.getActiveAccount()?.idTokenClaims?.login_hint
      });
    }
    console.error("Error while getting access token", error);
    throw error;
  }
};

apiClient.interceptors.request.use(
  async config => {
    config.headers.Authorization = await getAuthHeader();
    return config;
  },
  error => {
    Promise.reject(error as Error);
  }
);

textControlAPIClient.interceptors.request.use(
  async config => {
    config.headers.Authorization = await getAuthHeader();
    return config;
  },
  error => {
    Promise.reject(error as Error);
  }
);